/* eslint quote-props: 0 */  // --> OFF
/* eslint quotes: 0 */  // --> OFF
/* uv-prod */
export const AppConfigCustom = {
  "APPAK": "web-d4756066-466b-449e-942f-808b59158abe",                             //web-key from incomingAPIs.json
  "CLOUD_REGION": "eu-west-2",
  "COGNITO_USER_POOL": "eu-west-2_0wHAIOKyX",
  "COGNITO_USER_POOL_CLIENT_ID": "46isf1savv7qticmb577h97hm4",
  // "COGNITO_USER_POOL_CLIENT_ID": "5r7ls6f6n3rin5mukjpmee2ucq", // Redirects to localhost:8200 used in testing locally
  // "ADDITIONAL_HEADERS" : { 
    //   "x-apigw-api-id":"eojz01oil7"
    // },
  "ENDPOINT": "https://apis.dashboard.eagleeyeinvent.com",     //Invoke URL of ApiGateway
  "allowCamConfig": false,
  "allowLocal": false,
  "emailSuffix" : "@remotifai.com",
  "ENABLE_REFRESH_VIOLATION":true,
  "ENABLE_ALARM_NOTIFICATION":true,
  "ENABLE_SMS_NOTIFICATION":true,
  "ENABLE_ADVANCE_SETTINGS":false,
  "SHOW_TRY_GENERATIVE_AI_BUTTON":false,
  "ENABLE_FR_SETTINGS":true,
  "SHOW_FOOTER_INFO":true,
  "advancedShieldSettingUrl":"https://settings.sandbox.eagleeyeinvent.com/",
  "frontendSecretKey":"eeninvent-dashboard",
  "loginURL":"https://dashboard.eagleeyeinvent.com/login/cm",
  "eevmsLoginURL":"https://dashboard.eagleeyeinvent.com/login/vms",
  "logoName":"cameramanager",
  "headerLogoName":"een-logo-white",
  "product":"cm",
  "cmLoginURL":"https://auth.test.cameramanager.com/oauth/authorize?scope=write&client_id=devtest1&response_type=code&redirect_uri=",
  "vmsLoginURL":"https://auth.eagleeyenetworks.com/oauth2/authorize?scope=vms.all&client_id=5aabc980ded14a768827a287cdb7a140&response_type=code&redirect_uri=",
  "allowAuditConfig":true,
  "allowEventReviews":true,
  "autoUpdateEvent": false,
  "eventQueryLimit": 1000,
  "eventDownloadLimit": 1000,
  "allowBoundingBox":false,
  "camFilterStatusTimer":5, // in mins
  "camFilterStatusEnabled":true,
  "ENABLE_REPORT_TYPE": true,
  "dashboardEventQueryLimit": 1000,
  "eventRefreshInterval": 10000,
  "imageFeedRefreshInterval": 6000,
  "jpegPlayerRefreshInterval": 2000,
  "IDLE_TIMEOUT" : 1000*60*120,
  "SHOW_DIRECT_LINK_EVENT":false,
  "SHOW_VIOLATION":false,
  "SHOW_VIDEO":true,
  "ENABLE_REPORT_DOWNLOAD": true,
  "PDF_LIMIT":9000,
  "EXCEL_LIMIT":30000,
  "NAME": "Eagle Eye Networks",
  "mapK": "AhBVLeZEl9lnaie15GuW_pVIAUAMcmsWT-IGiDBmVLmBIVsaG0hMn9bm6ZN_yvDj",
  "viewMode": "List",
  "adminDashboard": "/orgs",
  "ES_EVENT_TYPES": {},
  "DEFAULT_ZONEINFO": 'Europe/London',
  "userDefaultSettings": {
    ALERT_EMAIL: "OFF",
    ALERT_SMS:"OFF",
    ALERT_TELEGRAM:"OFF",
    EVENT_VISIBILITY: "2",
    EVENT_EMAIL_ALERT: "3",
    CAMERAS: [],
    CAMERAS_TELEGRAM: [],
  },
  "userRoles": [
    {
      name: 'ADMIN',
      key: 'ADMIN',
    },
    {
      name: 'REGULAR',
      key: 'REGULAR',
    },
    {
      name: 'RESIDENT',
      key: 'RESIDENT',
    },
  ],
  placeTypes: [],
  camTypes: [],
  orgTypes: []
}